export const defaultTheme = {
    color: {
        background: "#f3f3f4",
        default: "#676a6c",
        // primary: "#007bff",
        primary: "#002559",
        secondary: "#6c757d",
        success: "#28a745",
        danger: "#dc3545",
        warning: "#ffc107",
        info: "#17a2b8",
        light: "#f8f9fa",
        dark: "#343a40",
    },
    components: {
        AppBar: {
            height: "50px",
            borderBottom: "2px solid rgba(0, 0, 0, 0.2)",
            background: "#333333",
            color: "#f8f9fa",
            css: "",
        },
        Sidebar: {
            width: "250px",
            background: "#d2d2d2",
            css: "",
        },
        SidebarElement: {
            background: "#2f4050",
            color: "#d0d3d7",
            fontWeight: 300,
            hover: {
                background: "#445362",
            },
            active: {
                background: "#445362",
                fontWeight: 600,
            },
        },
        PageTitle: {
            background: "#fff",
            title: {
                fontSize: "36px",
                fontWeight: "300",
                margin: "0px",
            },
            subtitle: {
                fontSize: "20px",
                fontWeight: "300",
                margin: "0px 0px 0px 6px",
            },
            css: "",
        },
        FloatInput: {},
        FloatInputContainer: {},
        FloatTextareaAutogrow: {
            css: `
                background: red;
            `,
        },
        Card: {
            css: `
                border:1px solid rgba(0,0,0,0.1);
                border-radius: 3px;
            `,
        },
        CardHeader: {
            css: `
                border-top: none;
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
                font-weight: 800;
                color: #333;
            `,
        },
        CardBody: {
            css: "",
        },
        CardFooter: {
            css: "",
        },
        Content: {
            padding: "15px",
        },
        h1: {
            fontSize: "2em",
            fontWeight: "300",
            css: "",
        },
        DropdownMenuElement: {
            css: `
                font-size: 14px;
                line-height: 18px;

                a {
                    font-size: 14px;
                    line-height: 18px;
                }
            `,
        },
    },
    sizes: {
        spacing: "15px",
        fontSize: "14px",
        breakpoints: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        },
    },
};
